import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { UserSelectorInput } from 'modules/core/components/Inputs/UserSelector'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

interface Props {
  onSuccess: (value: { reviewer_id: number | undefined }) => void
  onClose: () => void
}

const ActivateExpensesModal = ({ onSuccess, onClose }: Props) => {
  const [selectedIds, setSelectedId] = React.useState<number[]>([])
  const onSelect = (userIds: number[]) => setSelectedId(userIds)

  const onSubmit = async () => {
    await onSuccess({
      reviewer_id: selectedIds[0],
    })
  }

  return (
    <Modal
      illustration="monitor-flash"
      title={i18n.t('app_store_v2.apps.expenses.settings_install_modal.title')}
      description={i18n.t('app_store_v2.apps.expenses.settings_install_modal.description')}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Button disabled={!selectedIds.length} submit>
          {i18n.t('app_store_v2.apps.expenses.settings_install_modal.submit')}
        </Button>
      }
    >
      <UserSelectorInput
        label={i18n.t('app_store_v2.apps.expenses.settings_install_modal.label')}
        onSubmit={onSelect}
        selectedIds={selectedIds}
        users={users.models}
        multiselect={false}
      />
    </Modal>
  )
}

export default observer(ActivateExpensesModal)
